import { essScreens } from '../features/ess/screens';
import { managerScreens } from '../features/manager/screens';
import { hrScreens } from '../features/hr/screens';
import { payrollScreens } from '../features/payroll/screens';
import { adminScreens } from '../features/admin/screens';
import { SECTIONS, type ScreenDef } from './types';

/**
 * THE screen registry. Feature areas export arrays from src/features/<area>/screens.ts;
 * do not add screens here directly.
 */
export const SCREENS: ScreenDef[] = [...essScreens, ...managerScreens, ...hrScreens, ...payrollScreens, ...adminScreens];

const byName = new Map<string, ScreenDef>();
for (const s of SCREENS) {
  if (__DEV__ && byName.has(s.name)) console.warn(`[registry] duplicate screen name "${s.name}"`);
  byName.set(s.name, s);
}
if (__DEV__) {
  const paths = new Set<string>();
  for (const s of SCREENS) {
    if (paths.has(s.path)) console.warn(`[registry] duplicate path "${s.path}" (${s.name})`);
    paths.add(s.path);
    if (s.path.startsWith('/')) console.warn(`[registry] path must not start with "/" (${s.name})`);
  }
}

export const screenByName = (name: string) => byName.get(name);

export type CanFn = (...keys: string[]) => boolean;
export const isPermitted = (s: Pick<ScreenDef, 'perms'>, can: CanFn) => !s.perms || !s.perms.length || can(...s.perms);

/** Non-hidden, permitted screens grouped by section (sidebar, More, palette). */
export function navSections(can: CanFn, exclude?: Set<string>) {
  return SECTIONS.map((sec) => ({
    ...sec,
    items: SCREENS.filter((s) => s.section === sec.key && !s.hidden && isPermitted(s, can) && !exclude?.has(s.name)),
  })).filter((g) => g.items.length);
}
